namespace Entities {

    interface IPrinter {
        ipAddress: string;
        name: string;
        location: string;
    }
    export class Printer
        implements RavenDocument {
        
        id: string = "printers/";
        ipAddress: string;
        name: string;
        location: string;

        constructor(user: IPrinter) {
            this.ipAddress = user.ipAddress;
            this.name = user.name;
            this.location = user.location;
        }
    }
}